import {
  INDUSTRY_OPTIONS,
  POSITION_STATUS_OPTIONS,
  SOURCE_OF_FUNDS_OPTIONS
} from '../shared-constants';

const ID_TYPE_OPTIONS = [
  { value: 'international_passport', label: 'Passport' },
  { value: 'drivers_license', label: "Driver's License" },
  { value: 'national_id', label: 'National ID Card' }
];

const MONTHLY_VOLUME_OPTIONS = [
  { value: '0_5000', label: '$0 – $5,000' },
  { value: '5000_10000', label: '$5,000 – $10,000' },
  { value: '10000_30000', label: '$10,000 – $30,000' }
];

const PEP_RELATIONSHIP_OPTIONS = [
  { value: 'self', label: 'Self' },
  { value: 'spouse', label: 'Spouse' },
  { value: 'parent', label: 'Parent' },
  { value: 'child', label: 'Child' },
  { value: 'sibling', label: 'Sibling' },
  { value: 'close_associate', label: 'Close Associate' },
  { value: 'others', label: 'Others (Please specify)' }
];

export {
  ID_TYPE_OPTIONS,
  INDUSTRY_OPTIONS,
  MONTHLY_VOLUME_OPTIONS,
  PEP_RELATIONSHIP_OPTIONS,
  POSITION_STATUS_OPTIONS,
  SOURCE_OF_FUNDS_OPTIONS
};
